import React, { useState } from 'react';

import { message } from 'antd';

import { createPredefinedPrice, getErrorMessage } from '../../productApi';
import PriceFormFields, {
  INITIAL_PRICE_FORM_DATA,
  buildCreatePricePayload,
  usePriceFormState,
} from '../PriceForm';
import PriceFormPage from '../PriceFormPage';

export function PriceCreatePage(props) {
  const { history, match } = props;
  const { formData, updateField } = usePriceFormState(INITIAL_PRICE_FORM_DATA);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const description = formData.description.trim();
    if (!description) {
      message.error('Description is required');
      return;
    }

    try {
      setIsSubmitting(true);
      await createPredefinedPrice(
        match.params.sku,
        buildCreatePricePayload({
          ...formData,
          description,
        }),
      );
      message.success('Price created');
      history.push(`/edit/${match.params.sku}/prices`);
    } catch (error) {
      message.error(getErrorMessage(error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PriceFormPage history={history} title="Add New Price" onSubmit={handleSubmit} isSubmitting={isSubmitting}>
      <PriceFormFields formData={formData} onFieldChange={updateField} />
    </PriceFormPage>
  );
}

export default PriceCreatePage;
